let cache = null;
let cacheTimestamp = null;
let loadingPromise = null;
const CACHE_TTL = 24 * 60 * 60 * 1000;

function isCacheValid() {
  if (!cache || !cacheTimestamp) return false;
  return Date.now() - cacheTimestamp < CACHE_TTL;
}

async function loadStaticDataSources() {
  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = (async () => {
    try {
      const { supabase } = await import("../config/supabaseClient");
      const { data, error } = await supabase.functions.invoke('getStaticDataSources');
      if (!error && data?.data) {
        cache = data.data;
        cacheTimestamp = Date.now();
      } else {
        cache = {};
        cacheTimestamp = Date.now();
      }
    } catch (error) {
      console.error('Error loading static data sources:', error);
      cache = {};
      cacheTimestamp = Date.now();
    } finally {
      loadingPromise = null;
    }
  })();

  return loadingPromise;
}

export async function preloadStaticDataSources() {
  if (loadingPromise) {
    await loadingPromise;
    return;
  }
  cache = null;
  cacheTimestamp = null;
  loadingPromise = loadStaticDataSources();
  await loadingPromise;
}

export async function getStaticDataSource(dataSourceName) {
  if (!dataSourceName) {
    return [];
  }

  if (!isCacheValid()) {
    await loadStaticDataSources();
  }

  const normalizedName = dataSourceName.toLowerCase().trim();
  return cache?.[normalizedName] || [];
}

export function getStaticDataSourceSync(dataSourceName) {
  if (!dataSourceName || !isCacheValid()) {
    return [];
  }
  return cache[dataSourceName.toLowerCase().trim()] || [];
}

export function clearStaticDataSourceCache() {
  cache = null;
  cacheTimestamp = null;
  loadingPromise = null;
}
